export default "__VITE_ASSET__C9k06B_b__"